import { render } from "./OneCompanyChat.vue?vue&type=template&id=f9a5ef36&scoped=true"
import script from "./OneCompanyChat.vue?vue&type=script&lang=js"
export * from "./OneCompanyChat.vue?vue&type=script&lang=js"

import "./OneCompanyChat.vue?vue&type=style&index=0&id=f9a5ef36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a5ef36"]])

export default __exports__